module.exports = __webpack_public_path__ + "img/success.b566ce76.gif";